import * as React from "react";
import Stateless from "component/Stateless";
import { Box } from "bambu/lib/elements/box";
import { Container } from "bambu/lib/elements/container";
import { SubTitle, Title } from "bambu/lib/elements/title";
import { Hero, HeroBody, HeroProps } from "bambu/lib/layout/hero";
import headerStore from "view/header/HeaderStore";
import ElementUtil from "../generator/ElementUtil";
import "./style.css";

export interface PageProps extends HeroProps {
  header?: string;
  title?: string;
  subTitle?: string;
  isFluid?: boolean;
  isPaddingBottomless?: boolean;
  isPaddingTopless?: boolean;
  hasBox?: boolean;
  backButton?: boolean;
}

export default class Page extends Stateless<PageProps> {
  public static defaultProps = {
    isFluid: true,
    isPaddingBottomless: false,
    isPaddingTopless: false,
    hasBox: true,
    backButton: false,
  };

  private leftMenu: JSX.Element;

  public render(): JSX.Element {
    const { header, hasBox, title, isFluid, isPaddingBottomless, isPaddingTopless, subTitle, backButton, ...rest } = this.props;

    const bodyStyle: React.CSSProperties = {
      paddingLeft: 5,
      paddingRight: 5,
      backgroundColor: "#181818",
    };
    if (isPaddingBottomless) {
      bodyStyle["paddingBottom"] = 0;
    }
    if (isPaddingTopless) {
      bodyStyle["paddingTop"] = 0;
    }
    const children = (
      <>
        {title && <Title className="tvm-primary-color-text">{title}</Title>}
        {subTitle && <SubTitle className="tvm-secondary-color">{subTitle}</SubTitle>}
        {(title || subTitle) && <hr />}
        {this.props.children}
      </>
    );

    return (
      <Hero {...rest}>
        <HeroBody style={bodyStyle}>
          <Container isFluid={isFluid} className={isFluid ? "tvm-page-fluid" : undefined}>
            {hasBox ? <Box style={{ padding: "0.1em 0.75em 0.75em 0.75em", backgroundColor: "#181818" }}>{children}</Box> : children}
          </Container>
        </HeroBody>
      </Hero>
    );
  }

  public componentDidMount() {
    Page.changeHeader(this.props.header);
    if (this.props.backButton) {
      this.leftMenu = headerStore.leftMenus.get("menu");
      headerStore.addLeft(
        "menu",
        ElementUtil.generateButton({
          name: "back",
          icon: "chevron-left",
          onClick: () => {
            window.history.back();
          },
        })
      );
    }
  }

  public componentDidUpdate() {
    Page.changeHeader(this.props.header);
  }

  public componentWillUnmount() {
    if (this.props.backButton) {
      headerStore.addLeft("menu", this.leftMenu);
    }
  }

  public static changeHeader(header: string) {
    if (header) {
      headerStore.addCenter(
        "headerTitle",
        <span>
          <h3 className={"page-header"}>{header}</h3>
        </span>
      );
    } else {
      headerStore.removeCenter("headerTitle");
    }
  }
}
